import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 19,
	viewBox: "0 0 16 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "m9 .586-9 9v5.415h5.414l8.995-8.994L9 .586zM2 13v-2.586l7-6.999 2.582 2.59L4.586 13H2z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0 19h16v-2H0v2z",
		fill: "currentColor"
	})]
});
export default SvgPencil;
